import { Stack } from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'

import ChangeLogFeed from '@/components/ChangeLogFeed'
import ExpectedError from '@/components/ExpectedError'
import H2 from '@/components/H2'
import PageContainer from '@/components/PageContainer'
import UnexpectedError from '@/components/UnexpectedError'
import useSubjectChangeActivities from '@/hooks/useSubjectChangeActivities'
import useUser from '@/hooks/useUser'

interface ChangeLogPageParams {
  subjectId: string
}

const ChangeLogPage = () => {
  const { subjectId } = useParams<ChangeLogPageParams>()

  const { customerId } = useUser()

  const { fetchSubjectChangeActivities, data, loading, error } =
    useSubjectChangeActivities()

  const fetch = useCallback(
    () => fetchSubjectChangeActivities(customerId, subjectId),
    [customerId, subjectId, fetchSubjectChangeActivities],
  )

  useEffect(() => {
    if (customerId && subjectId) {
      fetch()
    }
  }, [customerId, subjectId, fetch])

  return (
    <PageContainer>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <H2>Change Log</H2>
        <Link to={`/applicant/${subjectId}`}>Back to applicant</Link>
      </Stack>
      {loading && <p>Loading...</p>}
      {error && <UnexpectedError error={error} onRetry={fetch} />}
      {data && data.length === 0 && (
        <ExpectedError
          imagePath="/assets/svg/failed-to-retrieve-applicant.svg"
          text="No change log activities found for this applicant."
        />
      )}
      {data && data.length > 0 && <ChangeLogFeed activities={data} />}
    </PageContainer>
  )
}

export default ChangeLogPage
